(function (window, document) {
  "use strict";

  var VERSION = "2026.10.10.2";
  var INSTANCE_COUNT = 0;
  var VIDEO_RE = /\.(mp4|mov|m4v|webm)(\?|$)/i;
  var POPULAR_KEYS = [
    "transformations", "skin-rejuvenation", "acne-treatment", "anti-wrinkle",
    "origin-laser", "hydrafacial", "lip-fillers", "hair-regrowth"
  ];
  var SCROLL_LOCK = window.DrSknnProofScrollLock || {
    count: 0,
    htmlOverflow: "",
    bodyOverflow: "",
    acquire: function () {
      if (this.count === 0) {
        this.htmlOverflow = document.documentElement.style.overflow || "";
        this.bodyOverflow = document.body ? document.body.style.overflow || "" : "";
      }
      this.count += 1;
      document.documentElement.style.overflow = "hidden";
      if (document.body) document.body.style.overflow = "hidden";
    },
    release: function () {
      this.count = Math.max(0, this.count - 1);
      if (this.count !== 0) return;
      document.documentElement.style.overflow = this.htmlOverflow;
      if (document.body) document.body.style.overflow = this.bodyOverflow;
    }
  };
  window.DrSknnProofScrollLock = SCROLL_LOCK;
  var AREA_RULES = {
    skin: /skin|acne|scar|pore|pigment|rosacea|vascular|redness|eczema|psoriasis|hydrafacial|profhilo|polynucleotide|rejuvenation|origin|wound/i,
    face: /wrinkle|rhinoplasty|traptox|hifu|under[ -]?eye|neck|jawline|platysmal|nefertiti|filler|tear trough|gummy|lip|cheek|chin|marionette|nasolabial|perioral|tmj/i,
    body: /body|fat reduction|tightening|cellulite|stretch mark|onda/i,
    hair: /hair|scalp|prp/i
  };

  function clean(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function escapeHtml(value) {
    return clean(value).replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  function slug(value) {
    return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  function stableToken(value) {
    var input = String(value || "");
    var hash = 5381;
    var index;
    for (index = 0; index < input.length; index += 1) {
      hash = ((hash << 5) + hash) ^ input.charCodeAt(index);
    }
    return (hash >>> 0).toString(36);
  }

  function safeMediaUrl(value) {
    var url = clean(value);
    if (!url) return "";
    if (/^(https?:)?\/\//i.test(url) || url.charAt(0) === "/") return url;
    return "";
  }

  function dataSource() {
    var data = window.DR_SKNN_BNA_DATA || {};
    return data.categories && typeof data.categories === "object" ? data.categories : data;
  }

  function mediaType(item) {
    if (!item) return "image";
    if (item.before && item.after) return "comparison";
    var explicit = clean(item.media || item.type).toLowerCase();
    if (explicit === "video" || VIDEO_RE.test(item.src || "")) return "video";
    return "image";
  }

  function normalizeItem(item, category, key, index) {
    var raw = typeof item === "string" ? { src: item } : (item || {});
    var type = mediaType(raw);
    var title = clean(category.title || category.label || key.replace(/-/g, " "));
    var src = safeMediaUrl(raw.src || raw.after || raw.before || "");
    var before = safeMediaUrl(raw.before || "");
    var after = safeMediaUrl(raw.after || "");
    var identity = clean(raw.id || raw.caseId || raw.case_id || raw.resultId || raw.result_id);
    if (!identity) identity = key + "-" + stableToken([before, after, src, raw.caption, raw.alt].join("|"));
    var explicitAreas = Array.isArray(raw.areas) ? raw.areas : clean(raw.area).split(/[\s,|]+/);
    var tags = Array.isArray(raw.tags) ? raw.tags : clean(raw.tags).split(/[,|]+/);
    var concerns = Array.isArray(raw.concerns) ? raw.concerns : clean(raw.concern).split(/[,|]+/);
    return {
      id: slug(identity) || (key + "-" + stableToken(src || index)),
      key: key,
      category: title,
      type: type,
      src: src,
      before: before,
      after: after,
      poster: safeMediaUrl(raw.poster || raw.thumbnail || (type === "video" ? "" : src)),
      alt: clean(raw.alt || raw.afterAlt || raw.beforeAlt || title + " result at Dr Sknn"),
      beforeAlt: clean(raw.beforeAlt || "Before treatment image for " + title),
      afterAlt: clean(raw.afterAlt || "After treatment image for " + title),
      caption: clean(raw.caption || category.subtitle || category.description || title),
      featured: Number(raw.featuredRank || raw.priority || 0) || 0,
      areas: explicitAreas.filter(function (area) { return !!AREA_RULES[area]; }),
      tags: tags.map(clean).filter(Boolean),
      concerns: concerns.map(clean).filter(Boolean),
      sessions: clean(raw.sessions || raw.sessionCount || raw.session_count),
      timeframe: clean(raw.timeframe || raw.timeline),
      consent: clean(raw.consent || raw.consentStatus || raw.consent_status),
      index: index
    };
  }

  function inferAreas(key, category) {
    var haystack = [key, category.title, category.label, category.subtitle, category.description, category.area, category.areas].join(" ");
    var explicit = Array.isArray(category.areas) ? category.areas.slice(0) : clean(category.area).split(/[\s,|]+/);
    var areas = explicit.filter(function (area) { return !!AREA_RULES[area]; });
    Object.keys(AREA_RULES).forEach(function (area) {
      if (AREA_RULES[area].test(haystack) && areas.indexOf(area) === -1) areas.push(area);
    });
    return areas;
  }

  function normalizeLibrary() {
    var source = dataSource();
    return Object.keys(source).map(function (key, order) {
      var category = source[key] || {};
      var rawItems = category.images || category.items || [];
      var items = rawItems.map(function (item, index) {
        return normalizeItem(item, category, key, index);
      }).filter(function (item) {
        return item.type === "comparison" ? !!item.before && !!item.after : !!item.src;
      });
      items.sort(function (a, b) {
        if (a.featured && b.featured) return a.featured - b.featured;
        if (a.featured) return -1;
        if (b.featured) return 1;
        return a.index - b.index;
      });
      var areas = inferAreas(key, category);
      items.forEach(function (item) {
        item.areas.forEach(function (area) {
          if (areas.indexOf(area) === -1) areas.push(area);
        });
      });
      return {
        key: key,
        title: clean(category.title || category.label || key.replace(/-/g, " ")),
        subtitle: clean(category.subtitle || category.description || "Real patient results. Individual outcomes vary."),
        areas: areas,
        featured: Number(category.featuredRank || category.priority || category.featured || 0) || 0,
        order: Number(category.order || order),
        items: items
      };
    }).filter(function (category) {
      return category.items.length > 0;
    });
  }

  function uniqueKeys(keys, library) {
    var available = {};
    var seen = {};
    library.forEach(function (category) { available[category.key] = true; });
    return (keys || []).filter(function (key) {
      if (!available[key] || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function relatedKeys(area, excluded, library) {
    var skip = {};
    (excluded || []).forEach(function (key) { skip[key] = true; });
    return library.filter(function (category) {
      return !skip[category.key] && (!area || area === "unsure" || category.areas.indexOf(area) !== -1);
    }).map(function (category) { return category.key; });
  }

  function popularKeys(library, limit) {
    var ranked = library.slice(0).sort(function (a, b) {
      if (a.featured && b.featured) return a.featured - b.featured;
      if (a.featured) return -1;
      if (b.featured) return 1;
      var aPreferred = POPULAR_KEYS.indexOf(a.key);
      var bPreferred = POPULAR_KEYS.indexOf(b.key);
      if (aPreferred !== -1 || bPreferred !== -1) {
        if (aPreferred === -1) return 1;
        if (bPreferred === -1) return -1;
        return aPreferred - bPreferred;
      }
      return a.order - b.order;
    });
    return ranked.slice(0, typeof limit === "number" ? limit : ranked.length).map(function (category) {
      return category.key;
    });
  }

  function interleavedItems(keys, library, limit) {
    var byKey = {};
    var output = [];
    var seen = {};
    var depth = 0;
    library.forEach(function (category) { byKey[category.key] = category; });
    while (output.length < limit) {
      var added = false;
      keys.forEach(function (key) {
        var category = byKey[key];
        var item = category && category.items[depth];
        if (!item || seen[item.id] || output.length >= limit) return;
        seen[item.id] = true;
        output.push(item);
        added = true;
      });
      if (!added) break;
      depth += 1;
    }
    return output;
  }

  function categoryByKey(library, key) {
    return library.filter(function (category) { return category.key === key; })[0] || library[0] || null;
  }

  function analytics(root, options, name, detail) {
    var payload = detail || {};
    try {
      root.dispatchEvent(new CustomEvent("drsknn:proof-studio", {
        bubbles: true,
        detail: { event: name, payload: payload }
      }));
    } catch (_) {}
    if (typeof options.onEvent === "function") options.onEvent(name, payload);
  }

  // Keep a small shared decoded cache; never preload the complete clinical library.
  var PHOTO_CACHE = new Map();
  function sizedPhoto(source, width) {
    var value = safeMediaUrl(source);
    if (!value) return "";
    var sizes = [280, 480, 700, 1000, 1400, 2000, 3000];
    var pixels = sizes.filter(function (size) { return size >= width; })[0] || 3000;
    try {
      var url = new URL(value, window.location.href);
      if (url.hostname === "cdn.shopify.com" || /\.myshopify\.com$/.test(url.hostname)) {
        url.searchParams.set("width", String(pixels));
        return url.href;
      }
      if (url.hostname === "ucarecdn.com") {
        if (/\/-\/preview\/\d+x\d+/.test(url.pathname)) url.pathname = url.pathname.replace(/\/-\/preview\/\d+x\d+/, "/-/preview/" + pixels + "x" + pixels);
        else url.pathname = url.pathname.replace(/^(\/[^/]+)\//, "$1/-/preview/" + pixels + "x" + pixels + "/");
        return url.href;
      }
    } catch (_) {}
    return value;
  }
  function photoIdentity(source) {
    var value = sizedPhoto(source, 280);
    try {
      var url = new URL(value, window.location.href);
      url.hash = "";
      url.searchParams.sort();
      return url.href;
    } catch (_) { return value; }
  }
  function readyPhoto(source, width) {
    var identity = photoIdentity(source);
    var adequate = null;
    var fallback = null;
    PHOTO_CACHE.forEach(function (record, url) {
      if (!record.ready || record.identity !== identity) return;
      var candidate = { url: url, width: record.image.naturalWidth || 0 };
      if (candidate.width >= width && (!adequate || candidate.width < adequate.width)) adequate = candidate;
      if (!fallback || candidate.width > fallback.width) fallback = candidate;
    });
    return adequate || fallback;
  }
  function loadPhoto(source, priority, large) {
    var cached = PHOTO_CACHE.get(source);
    if (cached) {
      if (priority === "high") cached.image.fetchPriority = "high";
      PHOTO_CACHE.delete(source);
      PHOTO_CACHE.set(source, cached);
      return cached.promise;
    }
    var image = new Image();
    image.decoding = "async";
    image.fetchPriority = priority || "low";
    var record = { image: image, ready: false, large: !!large, identity: photoIdentity(source) };
    record.promise = new Promise(function (resolve) {
      image.onload = function () {
        var decode = image.decode ? image.decode() : Promise.resolve();
        decode.catch(function () {}).then(function () { record.ready = image.naturalWidth > 0; resolve(record.ready); });
      };
      image.onerror = function () {
        if (PHOTO_CACHE.get(source) === record) PHOTO_CACHE.delete(source);
        resolve(false);
      };
    });
    PHOTO_CACHE.set(source, record);
    // Keep zoom detail for the current comparison pair without retaining many full-size decodes.
    var largeKeys = [];
    PHOTO_CACHE.forEach(function (entry, key) { if (entry.large) largeKeys.push(key); });
    while (largeKeys.length > 2) PHOTO_CACHE.delete(largeKeys.shift());
    while (PHOTO_CACHE.size > 32) PHOTO_CACHE.delete(PHOTO_CACHE.keys().next().value);
    image.src = source;
    return record.promise;
  }
  function photoTag(source, preview, alt, cls, eager) {
    // The stage may warm a different responsive bucket from this viewport estimate.
    // Reuse any decoded size of this same image, then hydrate to the measured stage width.
    var cached = readyPhoto(source, Math.min(1000, Math.max(480, window.innerWidth * 0.8)));
    var visible = cached ? cached.url : sizedPhoto(preview || source, 280);
    return '<img class="' + cls + '"' + (cls ? ' style="width:100%;height:100%;object-fit:contain"' : '') + ' loading="' + (eager ? "eager" : "lazy") + '" decoding="async" data-dps-photo="' + escapeHtml(source) + '" src="' + escapeHtml(visible) + '" alt="' + escapeHtml(alt) + '">';
  }

  function imageHtml(item, eager, lightbox) {
    var loading = eager ? "eager" : "lazy";
    var cls = lightbox ? "dps-lightbox-image" : "";
    if (item.type === "comparison") {
      return '<div class="dps-comparison">' +
        '<figure>' + photoTag(item.before, item.before, item.beforeAlt, cls, eager) + '<figcaption>Before</figcaption></figure>' +
        '<figure>' + photoTag(item.after, item.after, item.afterAlt, cls, eager) + '<figcaption>After</figcaption></figure>' +
      '</div>';
    }
    if (item.type === "video") {
      return '<video controls muted playsinline preload="metadata"' + (item.poster ? ' poster="' + escapeHtml(item.poster) + '"' : '') + ' aria-label="' + escapeHtml(item.alt) + '"><source src="' + escapeHtml(item.src) + '" type="' + (/.webm(\?|$)/i.test(item.src) ? "video/webm" : "video/mp4") + '"></video>';
    }
    return photoTag(item.src, thumbSource(item), item.alt, cls, eager);
  }

  function thumbSource(item) {
    return sizedPhoto(item.poster || item.after || item.src || item.before, 280);
  }

  function mount(root, rawOptions) {
    if (!root) return null;
    if (root._drsknnProofStudio && typeof root._drsknnProofStudio.destroy === "function") {
      root._drsknnProofStudio.destroy();
    }

    var options = rawOptions || {};
    var mode = options.mode === "matched" || options.mode === "preview" ? options.mode : "library";
    var instanceId = clean(root.id) || ("drsknn-proof-studio-" + (++INSTANCE_COUNT));
    var drawerId = instanceId + "-category-drawer";
    var library = normalizeLibrary();
    var allKeys = library.map(function (category) { return category.key; });
    var direct = uniqueKeys(options.categoryKeys || [], library);
    var requestedArea = AREA_RULES[options.area] ? options.area : "";
    if (!direct.length && requestedArea) {
      direct = relatedKeys(requestedArea, [], library).slice(0, 8);
    }
    if (!direct.length) direct = popularKeys(library, 8);
    var related = relatedKeys(options.area || "", direct, library);
    var tiers = mode === "matched" ? {
      direct: direct,
      related: related,
      all: allKeys
    } : { all: allKeys };
    var state = {
      tier: mode === "matched" ? "direct" : "all",
      category: options.initialCategory && allKeys.indexOf(options.initialCategory) !== -1 ? options.initialCategory : (direct[0] || allKeys[0] || ""),
      index: 0,
      thumbLimit: mode === "library" ? 4 : 12,
      search: "",
      group: "all",
      previewArea: requestedArea || "all",
      zoom: 1,
      lastFocus: null,
      lastFocusSelector: "",
      drawerLocked: false,
      lightboxLocked: false
    };
    var listeners = [];
    var renderVersion = 0;
    var destroyed = false;
    var imageToken = 0;

    function displayWidth(lightbox) {
      var element = root.querySelector(lightbox ? ".dps-lightbox-media" : ".dps-stage");
      var width = element && element.clientWidth || Math.min(root.clientWidth || window.innerWidth, 760);
      return Math.min(lightbox ? 3000 : 1400, width * Math.min(window.devicePixelRatio || 1, 1.5) * (lightbox ? state.zoom : 1));
    }
    function hydratePhotos(container, lightbox) {
      if (!container) return Promise.resolve();
      var images = container.querySelectorAll("img[data-dps-photo]");
      return Promise.all(Array.prototype.map.call(images, function (image) {
        var source = image.getAttribute("data-dps-photo");
        var width = image.clientWidth || displayWidth(lightbox);
        width = image.clientWidth ? width * Math.min(window.devicePixelRatio || 1, 1.5) * (lightbox ? state.zoom : 1) : width;
        var desired = sizedPhoto(source, Math.min(lightbox && state.zoom > 1 ? 3000 : 1400, width));
        var token = String(++imageToken);
        image.setAttribute("data-dps-photo-request", token);
        var cached = PHOTO_CACHE.get(desired);
        if (cached && cached.ready) { image.src = desired; return Promise.resolve(); }
        return loadPhoto(desired, "high", lightbox && state.zoom > 1 && width > 1400).then(function (ready) {
          // Detached previous-result nodes and superseded zoom requests cannot replace the selection.
          if (ready && !destroyed && image.isConnected && image.getAttribute("data-dps-photo-request") === token) image.src = desired;
        });
      }));
    }
    function prefetchItem(item, priority) {
      if (!item || item.type === "video") return Promise.resolve();
      var sources = item.type === "comparison" ? [item.before, item.after] : [item.src];
      return Promise.all(sources.map(function (source) { return loadPhoto(sizedPhoto(source, displayWidth(false)), priority || "low"); }));
    }
    function warmAdjacent(version) {
      var connection = window.navigator && window.navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) return;
      var category = activeCategory();
      if (!category || category.items.length < 2) return;
      var adjacent = [(state.index + 1) % category.items.length, (state.index + category.items.length - 1) % category.items.length];
      var run = function () {
        if (destroyed || version !== renderVersion || !adjacent.length) return;
        prefetchItem(category.items[adjacent.shift()]).then(run);
      };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 800 });
      else window.setTimeout(run, 80);
    }
    function hydrateResult() {
      var version = ++renderVersion;
      var visible = mode === "preview" ? root.querySelector(".dps-preview-grid") : root.querySelector("[data-dps-media]");
      hydratePhotos(visible, false).then(function () { if (version === renderVersion) warmAdjacent(version); });
    }
    function intentHandler(event) {
      var button = event.target.closest && event.target.closest("[data-dps-category], [data-dps-index], [data-dps-next], [data-dps-prev]");
      if (!button || !root.contains(button)) return;
      var category = button.hasAttribute("data-dps-category") ? categoryByKey(library, button.getAttribute("data-dps-category")) : activeCategory();
      if (!category) return;
      var position = button.hasAttribute("data-dps-category") ? 0 : button.hasAttribute("data-dps-index") ? Number(button.getAttribute("data-dps-index")) : (state.index + (button.hasAttribute("data-dps-prev") ? -1 : 1) + category.items.length) % category.items.length;
      prefetchItem(category.items[position], "high");
    }

    function on(target, event, handler) {
      target.addEventListener(event, handler);
      listeners.push(function () { target.removeEventListener(event, handler); });
    }

    function lock(kind) {
      var key = kind === "drawer" ? "drawerLocked" : "lightboxLocked";
      if (state[key]) return;
      state[key] = true;
      SCROLL_LOCK.acquire();
    }

    function unlock(kind) {
      var key = kind === "drawer" ? "drawerLocked" : "lightboxLocked";
      if (!state[key]) return;
      state[key] = false;
      SCROLL_LOCK.release();
    }

    function rememberFocus(target, selector) {
      state.lastFocus = target || document.activeElement;
      state.lastFocusSelector = selector || "";
    }

    function restoreFocus() {
      var target = state.lastFocus && document.contains(state.lastFocus)
        ? state.lastFocus
        : (state.lastFocusSelector ? root.querySelector(state.lastFocusSelector) : null);
      state.lastFocus = null;
      state.lastFocusSelector = "";
      if (target && typeof target.focus === "function") target.focus({ preventScroll: true });
    }

    function bookLabel() {
      return clean(options.bookLabel) || "Choose consultation";
    }

    function browseLabel() {
      return clean(options.browseLabel) || "Explore all results";
    }

    function tierKeys() {
      return tiers[state.tier] || allKeys;
    }

    function libraryGroupKeys() {
      if (mode !== "library" || state.group === "all") return allKeys;
      var popular = popularKeys(library, 12);
      return library.filter(function (category) {
        if (state.group === "popular") return popular.indexOf(category.key) !== -1;
        if (state.group === "transformations") {
          return /transform|journey/i.test(category.key + " " + category.title);
        }
        if (state.group === "regenerative") {
          return /polynucleotide|profhilo|exosome|prp|biological|wound|regener/i.test(category.key + " " + category.title);
        }
        return category.areas.indexOf(state.group) !== -1;
      }).map(function (category) { return category.key; });
    }

    function filteredCategories() {
      var keys = mode === "library" ? libraryGroupKeys() : tierKeys();
      var query = state.search.toLowerCase();
      return library.filter(function (category) {
        return keys.indexOf(category.key) !== -1 && (!query || (category.title + " " + category.subtitle).toLowerCase().indexOf(query) !== -1);
      });
    }

    function activeCategory() {
      return categoryByKey(library, state.category);
    }

    function activeItem() {
      var category = activeCategory();
      if (!category || !category.items.length) return null;
      if (state.index >= category.items.length) state.index = 0;
      if (state.index < 0) state.index = category.items.length - 1;
      return category.items[state.index];
    }

    function ensureActiveCategory() {
      var categories = filteredCategories();
      if (!categories.length) return;
      var activeExists = categories.some(function (category) { return category.key === state.category; });
      if (!activeExists) state.category = categories[0].key;
    }

    function tierHtml() {
      if (mode === "library") {
        var groups = [
          ["all", "All results"],
          ["popular", "Popular"],
          ["face", "Face"],
          ["skin", "Skin"],
          ["body", "Body"],
          ["hair", "Hair"],
          ["regenerative", "Regenerative"],
          ["transformations", "Transformations"]
        ];
        return '<div class="dps-groups" role="group" aria-label="Filter result categories">' +
          groups.map(function (group) {
            var active = state.group === group[0];
            return '<button class="dps-tier' + (active ? " is-active" : "") + '" type="button" data-dps-group="' + group[0] + '" aria-pressed="' + (active ? "true" : "false") + '">' + group[1] + '</button>';
          }).join("") +
        '</div>';
      }
      var directLabel = clean(options.directLabel) || ((options.categoryKeys || []).length || requestedArea ? "Closest to your concerns" : "Popular across the clinic");
      return '<div class="dps-tiers" role="group" aria-label="Result groups">' +
        '<button class="dps-tier' + (state.tier === "direct" ? " is-active" : "") + '" type="button" data-dps-tier="direct" aria-pressed="' + (state.tier === "direct" ? "true" : "false") + '">' + escapeHtml(directLabel) + '</button>' +
        '<button class="dps-tier' + (state.tier === "related" ? " is-active" : "") + '" type="button" data-dps-tier="related" aria-pressed="' + (state.tier === "related" ? "true" : "false") + '">Related clinic results</button>' +
        '<button class="dps-tier' + (state.tier === "all" ? " is-active" : "") + '" type="button" data-dps-tier="all" aria-pressed="' + (state.tier === "all" ? "true" : "false") + '">Explore the full clinic</button>' +
      '</div>';
    }

    function categoryListHtml(drawer) {
      var categories = filteredCategories();
      if (!categories.length) return '<div class="dps-empty"><div>No categories match those filters.<br><button class="dps-load-more" type="button" data-dps-clear>Clear filters</button></div></div>';
      return categories.map(function (category) {
        var active = category.key === state.category;
        return '<button class="dps-category-button' + (active ? " is-active" : "") + '" type="button" data-dps-category="' + escapeHtml(category.key) + '" aria-pressed="' + (active ? "true" : "false") + '"><span>' + escapeHtml(category.title) + '</span><small>' + category.items.length + '</small></button>';
      }).join("");
    }

    function introHtml() {
      if (options.compact) return "";
      var title = options.title || (mode === "matched" ? "Relevant real results" : "Before & After Studio");
      var copy = options.description || (mode === "matched" ? "Real clinic examples related to what you selected. Your clinician will confirm the right route in person." : "Explore real Dr Sknn patient journeys across skin, face, body and hair.");
      return '<header class="dps-intro"><div class="dps-intro-copy"><span class="dps-eyebrow">' + (mode === "matched" ? "Matched clinic proof" : "Real Dr Sknn results") + '</span><h2 id="' + escapeHtml(instanceId) + '-title">' + escapeHtml(title) + '</h2><p>' + escapeHtml(copy) + '</p></div>' + (typeof options.onBook === "function" ? '<button class="dps-action" type="button" data-dps-book>' + escapeHtml(bookLabel()) + ' <span aria-hidden="true">→</span></button>' : '') + '</header>';
    }

    function itemDetailsHtml(item) {
      if (!item) return "";
      var details = [];
      var matchReason = "";
      if (mode === "matched" && typeof options.matchReason === "function") {
        try {
          matchReason = clean(options.matchReason(item, activeCategory()));
        } catch (_) {}
      }
      if (item.sessions) details.push("Sessions: " + item.sessions);
      if (item.timeframe) details.push("Timeframe: " + item.timeframe);
      var reasonHtml = matchReason ? '<p class="dps-match-reason"><strong>Why this is shown</strong><span>' + escapeHtml(matchReason) + '</span></p>' : "";
      if (!details.length) return reasonHtml;
      return reasonHtml + '<ul class="dps-case-details" aria-label="Result details">' + details.map(function (detail) {
        return '<li>' + escapeHtml(detail) + '</li>';
      }).join("") + '</ul>';
    }

    function previewKeys() {
      var configured = uniqueKeys(options.categoryKeys || [], library);
      if (configured.length) return configured;
      if (state.previewArea !== "all") {
        var areaKeys = relatedKeys(state.previewArea, [], library);
        if (areaKeys.length) return areaKeys;
      }
      return popularKeys(library, 12);
    }

    function previewItems() {
      return interleavedItems(previewKeys(), library, Math.max(3, Math.min(8, Number(options.previewLimit || 4))));
    }

    function previewCardHtml(item) {
      var preview = thumbSource(item);
      var category = categoryByKey(library, item.key);
      var activeIndex = category ? category.items.indexOf(item) : 0;
      var media = preview
        ? '<img loading="lazy" decoding="async" src="' + escapeHtml(preview) + '" alt="' + escapeHtml(item.alt) + '">'
        : '<span class="dps-preview-placeholder">Result image unavailable</span>';
      var badge = item.type === "video" ? '<span class="dps-preview-badge">Video</span>' : item.type === "comparison" ? '<span class="dps-preview-badge">Before &amp; after</span>' : "";
      var actionLabel = item.type === "video" ? "Play " : "Enlarge ";
      return '<button class="dps-preview-card" type="button" data-dps-preview-case data-dps-case-id="' + escapeHtml(item.id) + '" data-dps-category="' + escapeHtml(item.key) + '" data-dps-preview-index="' + Math.max(0, activeIndex) + '" aria-label="' + actionLabel + escapeHtml(item.category) + ' result">' +
        '<span class="dps-preview-media">' + media + badge + '</span>' +
        '<span class="dps-preview-copy"><strong>' + escapeHtml(item.category) + '</strong><span>' + escapeHtml(item.caption) + '</span></span>' +
      '</button>';
    }

    function previewHtml() {
      var title = options.title || "Real results, relevant to you";
      var copy = options.description || "Choose an area to see a small selection from the shared Dr Sknn result library.";
      var items = previewItems();
      var areas = [
        ["all", "Popular"],
        ["skin", "Skin"],
        ["face", "Face"],
        ["body", "Body"],
        ["hair", "Hair"]
      ];
      if (!library.length) {
        return '<section class="dps-preview" aria-labelledby="' + escapeHtml(instanceId) + '-title"><div class="dps-status" role="status"><strong>Results are temporarily unavailable.</strong><span>You can still choose a consultation or open the full results page.</span><a href="/pages/before-after-pictures-dr-sknn">Open results page</a></div></section>';
      }
      return '<section class="dps-preview" aria-labelledby="' + escapeHtml(instanceId) + '-title">' +
        '<header class="dps-preview-head"><div><span class="dps-eyebrow">Shared clinic proof</span><h2 id="' + escapeHtml(instanceId) + '-title">' + escapeHtml(title) + '</h2><p>' + escapeHtml(copy) + '</p></div><div class="dps-preview-actions">' +
          (typeof options.onBook === "function" ? '<button class="dps-action" type="button" data-dps-book>' + escapeHtml(bookLabel()) + '</button>' : '') +
          '<a class="dps-secondary-action" href="/pages/before-after-pictures-dr-sknn" data-dps-browse>' + escapeHtml(browseLabel()) + '</a>' +
        '</div></header>' +
        '<div class="dps-preview-filters" role="group" aria-label="Filter preview results by area">' + areas.map(function (area) {
          var active = state.previewArea === area[0];
          return '<button type="button" data-dps-preview-area="' + area[0] + '" aria-pressed="' + (active ? "true" : "false") + '"' + (active ? ' class="is-active"' : "") + '>' + area[1] + '</button>';
        }).join("") + '</div>' +
        '<div class="dps-preview-grid">' + items.map(previewCardHtml).join("") + '</div>' +
        '<p class="dps-disclaimer">Real Dr Sknn patient results. Individual outcomes vary and suitability is confirmed in clinic.</p>' +
      '</section>';
    }

    function stageContents(item, items) {
      return '<div class="dps-media" data-dps-media>' + (item ? imageHtml(item, true, false) : '<div class="dps-empty">No results are currently published in this category.</div>') + '</div>' +
            (items.length > 1 ? (item && item.type !== "video" ? '<button class="dps-stage-tap-zone dps-stage-tap-zone--prev" type="button" data-dps-prev aria-label="Show previous result from the left side of the image"></button><button class="dps-stage-tap-zone dps-stage-tap-zone--next" type="button" data-dps-next aria-label="Show next result from the right side of the image"></button>' : '') + '<button class="dps-icon-button dps-stage-nav" type="button" data-dps-prev aria-label="Previous result">‹</button><button class="dps-icon-button dps-stage-nav" type="button" data-dps-next aria-label="Next result">›</button>' : '') +
            (item ? '<span class="dps-stage-count">' + (state.index + 1) + ' / ' + items.length + '</span>' : '');
    }
    function metaContents(item) {
      return '<div><p class="dps-caption">' + escapeHtml(item ? item.caption : "") + '</p>' + itemDetailsHtml(item) + '</div><div class="dps-meta-actions">' + (item && item.type !== "video" ? '<button class="dps-zoom-button" type="button" data-dps-open-lightbox><span aria-hidden="true">＋</span> Enlarge result</button>' : '') + (mode === "library" && typeof options.onBook === "function" ? '<button class="dps-result-book" type="button" data-dps-book>' + escapeHtml(bookLabel()) + '</button>' : '') + '</div>';
    }
    function renderResult(lightboxOpen) {
      var item = activeItem();
      var category = activeCategory();
      var stage = root.querySelector(".dps-stage");
      var activeButton = document.activeElement;
      var focusAttribute = activeButton && stage && stage.contains(activeButton) && activeButton.hasAttribute("data-dps-next") ? "data-dps-next" : activeButton && stage && stage.contains(activeButton) && activeButton.hasAttribute("data-dps-prev") ? "data-dps-prev" : "";
      var focusClass = activeButton && activeButton.classList.contains("dps-stage-tap-zone") ? ".dps-stage-tap-zone" : ".dps-stage-nav";
      if (stage && category) {
        stage.classList.toggle("is-video", !!item && item.type === "video");
        stage.innerHTML = stageContents(item, category.items);
        var meta = root.querySelector(".dps-meta");
        if (meta) meta.innerHTML = metaContents(item);
        Array.prototype.forEach.call(root.querySelectorAll("[data-dps-index]"), function (thumb) {
          var selected = Number(thumb.getAttribute("data-dps-index")) === state.index;
          thumb.classList.toggle("is-active", selected);
          if (selected) thumb.setAttribute("aria-current", "true"); else thumb.removeAttribute("aria-current");
        });
        if (focusAttribute && !lightboxOpen) {
          var replacement = stage.querySelector(focusClass + "[" + focusAttribute + "]");
          // A photo-to-video transition can remove the tap zone; use the visible control.
          if (!replacement || !replacement.getClientRects().length) {
            replacement = Array.prototype.filter.call(stage.querySelectorAll("[" + focusAttribute + "]"), function (button) { return button.getClientRects().length > 0; })[0];
          }
          if (replacement) replacement.focus({ preventScroll: true });
        }
      }
      var lightbox = root.querySelector("[data-dps-lightbox]");
      if (lightbox) lightbox.outerHTML = '<div class="dps-lightbox" aria-hidden="true" data-dps-lightbox></div>';
      hydrateResult();
      if (lightboxOpen) openLightbox(null, true);
    }

    function shellHtml() {
      var category = activeCategory();
      var item = activeItem();
      var items = category ? category.items : [];
      var thumbs = items.slice(0, state.thumbLimit).map(function (thumb, index) {
        var source = thumbSource(thumb);
        var preview = thumb.type === "video"
          ? '<video muted playsinline preload="metadata" src="' + escapeHtml(thumb.src) + '" aria-hidden="true"></video>'
          : (source ? '<img loading="lazy" decoding="async" src="' + escapeHtml(source) + '" alt="">' : '');
        return '<button class="dps-thumb' + (index === state.index ? " is-active" : "") + '" type="button" data-dps-index="' + index + '" aria-label="View result ' + (index + 1) + ' of ' + items.length + '"' + (index === state.index ? ' aria-current="true"' : '') + '>' +
          preview +
          '<span class="dps-thumb-index">' + (index + 1) + '</span></button>';
      }).join("");
      if (items.length > state.thumbLimit) {
        thumbs += '<button class="dps-load-more" type="button" data-dps-more>' + (mode === "library" ? "View all " + items.length : "Show " + Math.min(12, items.length - state.thumbLimit) + " more") + '</button>';
      }
      var categoryTitle = category ? category.title : "Results";
      var categorySubtitle = category ? category.subtitle : "Choose a category to begin.";
      return '<div class="dps-shell">' +
        '<aside class="dps-sidebar"><p class="dps-sidebar-title">Browse results</p>' + tierHtml() + '<input class="dps-search" type="search" placeholder="Find a category" aria-label="Find a result category" data-dps-search value="' + escapeHtml(state.search) + '"><div class="dps-category-list" data-dps-category-list>' + categoryListHtml(false) + '</div></aside>' +
        '<main class="dps-main">' +
          '<button class="dps-mobile-category" type="button" data-dps-open-drawer aria-haspopup="dialog" aria-controls="' + escapeHtml(drawerId) + '" aria-expanded="false"><span><small>Choose result category</small>' + escapeHtml(categoryTitle) + '</span><span aria-hidden="true">⌄</span></button>' +
          '<header class="dps-category-head"><div><span class="dps-eyebrow">' + (mode === "matched" ? "Relevant category" : "Selected category") + '</span><h3>' + escapeHtml(categoryTitle) + '</h3><p>' + escapeHtml(categorySubtitle) + '</p></div>' + (options.compact && typeof options.onBook === "function" ? '<button class="dps-action" type="button" data-dps-book>' + escapeHtml(bookLabel()) + '</button>' : '') + '</header>' +
          '<div class="dps-viewer-grid"><section class="dps-viewer" aria-live="polite"><div class="dps-stage' + (item && item.type === "video" ? " is-video" : "") + '">' + stageContents(item, items) +
          '</div>' + (items.length > 1 ? '<p class="dps-mobile-tap-hint" aria-hidden="true">Tap the left or right side of the image to browse results.</p>' : '') + '<div class="dps-meta"><div><p class="dps-caption">' + escapeHtml(item ? item.caption : "") + '</p>' + itemDetailsHtml(item) + '</div><div class="dps-meta-actions">' + (item && item.type !== "video" ? '<button class="dps-zoom-button" type="button" data-dps-open-lightbox><span aria-hidden="true">＋</span> Enlarge result</button>' : '') + (mode === "library" && typeof options.onBook === "function" ? '<button class="dps-result-book" type="button" data-dps-book>' + escapeHtml(bookLabel()) + '</button>' : '') + '</div></div></section><aside class="dps-thumbs" aria-label="Results in ' + escapeHtml(categoryTitle) + '">' + thumbs + '</aside></div>' +
        '</main>' +
      '</div>';
    }

    function drawerHtml() {
      return '<div class="dps-drawer" id="' + escapeHtml(drawerId) + '" aria-hidden="true" data-dps-drawer><section class="dps-drawer-panel" role="dialog" aria-modal="true" aria-label="Choose a result category"><div class="dps-drawer-head"><strong>Choose a category</strong><button class="dps-drawer-close" type="button" data-dps-close-drawer aria-label="Close category list">×</button></div>' + tierHtml() + '<input class="dps-search" type="search" placeholder="Find a category" aria-label="Find a result category" data-dps-drawer-search value="' + escapeHtml(state.search) + '"><div class="dps-drawer-list" data-dps-drawer-list>' + categoryListHtml(true) + '</div></section></div>';
    }

    function lightboxHtml() {
      var item = activeItem();
      if (!item) return '<div class="dps-lightbox" aria-hidden="true" data-dps-lightbox></div>';
      var expanded = imageHtml(item, true, true);
      var tapZones = item.type === "video" ? "" : '<button class="dps-lightbox-tap-zone dps-lightbox-tap-zone--prev" type="button" data-dps-lightbox-prev aria-label="Show previous result from the left side of the enlarged image"></button><button class="dps-lightbox-tap-zone dps-lightbox-tap-zone--next" type="button" data-dps-lightbox-next aria-label="Show next result from the right side of the enlarged image"></button>';
      var zoomTools = item.type === "video" ? "" : '<div class="dps-lightbox-tools"><button class="dps-lightbox-zoom" type="button" data-dps-zoom="out" aria-label="Zoom out">−</button><button class="dps-lightbox-zoom" type="button" data-dps-zoom="reset" aria-label="Reset zoom">1:1</button><button class="dps-lightbox-zoom" type="button" data-dps-zoom="in" aria-label="Zoom in">＋</button></div>';
      return '<div class="dps-lightbox" aria-hidden="true" data-dps-lightbox role="dialog" aria-modal="true" aria-label="Expanded result"><button class="dps-lightbox-close" type="button" data-dps-close-lightbox aria-label="Close expanded result">×</button><button class="dps-lightbox-nav" type="button" data-dps-lightbox-prev aria-label="Previous result">‹</button><div class="dps-lightbox-media">' + expanded + tapZones + '</div><button class="dps-lightbox-nav" type="button" data-dps-lightbox-next aria-label="Next result">›</button><p class="dps-lightbox-caption">' + escapeHtml(item.caption) + '</p>' + zoomTools + '</div>';
    }

    function render() {
      ensureActiveCategory();
      root.className = (root.className || "") + (root.className.indexOf("drsknn-proof-studio") === -1 ? " drsknn-proof-studio" : "");
      root.setAttribute("data-proof-mode", mode);
      root.innerHTML = mode === "preview"
        ? previewHtml() + '<div class="dps-lightbox" aria-hidden="true" data-dps-lightbox></div>'
        : introHtml() + shellHtml() + drawerHtml() + '<div class="dps-lightbox" aria-hidden="true" data-dps-lightbox></div>';
      hydrateResult();
    }

    function chooseCategory(key) {
      if (allKeys.indexOf(key) === -1) return;
      state.category = key;
      state.index = 0;
      state.thumbLimit = mode === "library" ? 4 : 12;
      state.zoom = 1;
      analytics(root, options, "category_select", { category: key, mode: mode });
      render();
    }

    function move(direction, lightboxOpen) {
      var category = activeCategory();
      if (!category || !category.items.length) return;
      state.index = (state.index + direction + category.items.length) % category.items.length;
      state.zoom = 1;
      analytics(root, options, "result_view", { category: category.key, index: state.index, caseId: activeItem() ? activeItem().id : "" });
      renderResult(lightboxOpen);
    }

    function openDrawer(trigger) {
      var drawer = root.querySelector("[data-dps-drawer]");
      if (!drawer) return;
      rememberFocus(trigger, "[data-dps-open-drawer]");
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      var picker = root.querySelector("[data-dps-open-drawer]");
      if (picker) picker.setAttribute("aria-expanded", "true");
      lock("drawer");
      var close = drawer.querySelector("[data-dps-close-drawer]");
      if (close) close.focus({ preventScroll: true });
    }

    function closeDrawer() {
      var drawer = root.querySelector("[data-dps-drawer]");
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      var picker = root.querySelector("[data-dps-open-drawer]");
      if (picker) picker.setAttribute("aria-expanded", "false");
      unlock("drawer");
      restoreFocus();
    }

    function restoreDrawer(focusSelector) {
      var drawer = root.querySelector("[data-dps-drawer]");
      if (!drawer) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      var picker = root.querySelector("[data-dps-open-drawer]");
      if (picker) picker.setAttribute("aria-expanded", "true");
      lock("drawer");
      var focusTarget = focusSelector ? drawer.querySelector(focusSelector) : null;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function openLightbox(trigger, preserveFocus) {
      var lightbox = root.querySelector("[data-dps-lightbox]");
      if (!lightbox) return;
      if (!lightbox.innerHTML) {
        lightbox.outerHTML = lightboxHtml();
        lightbox = root.querySelector("[data-dps-lightbox]");
      }
      if (!lightbox || !lightbox.innerHTML) return;
      if (!preserveFocus) {
        rememberFocus(
          trigger || document.activeElement,
          trigger && trigger.hasAttribute && trigger.hasAttribute("data-dps-open-lightbox")
            ? "[data-dps-open-lightbox]"
            : trigger && trigger.closest && trigger.closest("[data-dps-media]")
              ? "[data-dps-media] img"
              : ""
        );
      }
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      lock("lightbox");
      hydratePhotos(lightbox, true);
      var close = lightbox.querySelector("[data-dps-close-lightbox]");
      if (close) close.focus({ preventScroll: true });
      analytics(root, options, "lightbox_open", { category: state.category, index: state.index });
    }

    function closeLightbox() {
      var lightbox = root.querySelector("[data-dps-lightbox]");
      if (!lightbox) return;
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      unlock("lightbox");
      restoreFocus();
    }

    function updateLightboxZoom() {
      var images = root.querySelectorAll("[data-dps-lightbox] img");
      Array.prototype.forEach.call(images, function (image) {
        image.style.setProperty("--dps-zoom", state.zoom);
      });
      hydratePhotos(root.querySelector("[data-dps-lightbox]"), true);
    }

    function clickHandler(event) {
      var origin = event.target;
      if (!origin || typeof origin.closest !== "function" || !root.contains(origin)) return;
      var mediaImage = origin.closest("[data-dps-media] img");
      var browseLink = origin.closest("[data-dps-browse]");
      if (browseLink) {
        var linkedItem = activeItem();
        var linkedDetail = { category: state.category, caseId: linkedItem ? linkedItem.id : "", area: state.previewArea === "all" ? requestedArea : state.previewArea, mode: mode };
        analytics(root, options, "browse_click", linkedDetail);
        if (typeof options.onBrowse === "function") {
          event.preventDefault();
          options.onBrowse(linkedDetail);
        }
        return;
      }
      if (origin.matches("[data-dps-drawer].is-open")) {
        closeDrawer();
        return;
      }
      if (origin.matches("[data-dps-lightbox].is-open")) {
        closeLightbox();
        return;
      }
      var target = origin.closest("button");
      if (!target) {
        if (mediaImage) openLightbox(mediaImage);
        return;
      }
      if (target.hasAttribute("data-dps-book")) {
        var bookingItem = activeItem();
        var bookingDetail = { category: state.category, caseId: bookingItem ? bookingItem.id : "", area: state.previewArea === "all" ? requestedArea : state.previewArea, mode: mode };
        analytics(root, options, "book_click", bookingDetail);
        if (typeof options.onBook === "function") options.onBook(state.category, bookingDetail);
        return;
      }
      if (target.hasAttribute("data-dps-preview-area")) {
        state.previewArea = target.getAttribute("data-dps-preview-area") || "all";
        var areaKeys = previewKeys();
        state.category = areaKeys[0] || allKeys[0] || "";
        state.index = 0;
        analytics(root, options, "preview_area_select", { area: state.previewArea });
        render();
        return;
      }
      if (target.hasAttribute("data-dps-preview-case")) {
        var previewCategory = target.getAttribute("data-dps-category");
        var previewIndex = Number(target.getAttribute("data-dps-preview-index"));
        if (allKeys.indexOf(previewCategory) === -1) return;
        state.category = previewCategory;
        state.index = isFinite(previewIndex) ? previewIndex : 0;
        state.zoom = 1;
        rememberFocus(null, '[data-dps-case-id="' + (target.getAttribute("data-dps-case-id") || "") + '"]');
        analytics(root, options, "preview_result_open", { category: state.category, index: state.index, caseId: activeItem() ? activeItem().id : "" });
        render();
        openLightbox(null, true);
        return;
      }
      if (target.hasAttribute("data-dps-tier")) {
        var tierFromDrawer = Boolean(target.closest("[data-dps-drawer]"));
        state.tier = target.getAttribute("data-dps-tier");
        state.search = "";
        state.category = tierKeys()[0] || allKeys[0] || "";
        state.index = 0;
        render();
        if (tierFromDrawer) {
          restoreDrawer('[data-dps-tier="' + state.tier + '"]');
        }
        return;
      }
      if (target.hasAttribute("data-dps-group")) {
        var groupFromDrawer = Boolean(target.closest("[data-dps-drawer]"));
        state.group = target.getAttribute("data-dps-group") || "all";
        state.search = "";
        state.category = libraryGroupKeys()[0] || allKeys[0] || "";
        state.index = 0;
        state.thumbLimit = 4;
        render();
        if (groupFromDrawer) {
          restoreDrawer('[data-dps-group="' + state.group + '"]');
        }
        return;
      }
      if (target.hasAttribute("data-dps-clear")) {
        state.group = "all";
        state.search = "";
        state.category = allKeys[0] || "";
        state.index = 0;
        render();
        return;
      }
      if (target.hasAttribute("data-dps-category")) {
        var selectedFromDrawer = Boolean(target.closest("[data-dps-drawer]"));
        chooseCategory(target.getAttribute("data-dps-category"));
        if (selectedFromDrawer) {
          unlock("drawer");
          var replacementPicker = root.querySelector("[data-dps-open-drawer]");
          if (replacementPicker) replacementPicker.focus({ preventScroll: true });
        }
        return;
      }
      if (target.hasAttribute("data-dps-index")) {
        state.index = Number(target.getAttribute("data-dps-index")) || 0;
        state.zoom = 1;
        analytics(root, options, "result_view", { category: state.category, index: state.index, caseId: activeItem() ? activeItem().id : "" });
        renderResult(false);
        return;
      }
      if (target.hasAttribute("data-dps-prev")) { move(-1, false); return; }
      if (target.hasAttribute("data-dps-next")) { move(1, false); return; }
      if (target.hasAttribute("data-dps-more")) {
        state.thumbLimit = mode === "library" ? (activeCategory() ? activeCategory().items.length : 4) : state.thumbLimit + 12;
        render();
        return;
      }
      if (target.hasAttribute("data-dps-open-drawer")) { openDrawer(target); return; }
      if (target.hasAttribute("data-dps-close-drawer")) { closeDrawer(); return; }
      if (target.hasAttribute("data-dps-open-lightbox")) { openLightbox(target); return; }
      if (target.hasAttribute("data-dps-close-lightbox")) { closeLightbox(); return; }
      if (target.hasAttribute("data-dps-lightbox-prev")) { move(-1, true); return; }
      if (target.hasAttribute("data-dps-lightbox-next")) { move(1, true); return; }
      if (target.hasAttribute("data-dps-zoom")) {
        var action = target.getAttribute("data-dps-zoom");
        state.zoom = action === "in" ? Math.min(3, state.zoom + 0.25) : action === "out" ? Math.max(1, state.zoom - 0.25) : 1;
        updateLightboxZoom();
        analytics(root, options, "zoom", { zoom: state.zoom });
      }
    }

    function inputHandler(event) {
      if (!event.target.matches("[data-dps-search], [data-dps-drawer-search]")) return;
      var searchFromDrawer = event.target.matches("[data-dps-drawer-search]");
      state.search = clean(event.target.value);
      if (mode === "library" && state.search) state.group = "all";
      ensureActiveCategory();
      render();
      if (searchFromDrawer) {
        restoreDrawer();
      }
      var selector = searchFromDrawer ? "[data-dps-drawer-search]" : "[data-dps-search]";
      var replacement = root.querySelector(selector);
      if (replacement) {
        replacement.focus();
        replacement.setSelectionRange(state.search.length, state.search.length);
      }
    }

    function keyHandler(event) {
      var lightbox = root.querySelector("[data-dps-lightbox].is-open");
      var drawer = root.querySelector("[data-dps-drawer].is-open");
      var activeDialog = lightbox || drawer;
      if (event.key === "Escape") {
        if (lightbox) { closeLightbox(); return; }
        if (drawer) closeDrawer();
        return;
      }
      if (lightbox && (event.key === "ArrowLeft" || event.key === "ArrowRight")) {
        event.preventDefault();
        move(event.key === "ArrowLeft" ? -1 : 1, true);
        return;
      }
      if (event.key !== "Tab" || !activeDialog) return;
      var focusable = Array.prototype.slice.call(activeDialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], video[controls]'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    render();
    on(root, "click", clickHandler);
    on(root, "input", inputHandler);
    on(root, "pointerover", intentHandler);
    on(root, "focusin", intentHandler);
    on(document, "keydown", keyHandler);
    var resizeTimer = 0;
    on(window, "resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (destroyed || !root.isConnected) return;
        hydrateResult();
        var openImage = root.querySelector("[data-dps-lightbox].is-open");
        if (openImage) hydratePhotos(openImage, true);
      }, 150);
    });
    listeners.push(function () { window.clearTimeout(resizeTimer); });
    var mediaErrorHandler = function (event) {
      var media = event.target;
      if (!media || (media.tagName !== "IMG" && media.tagName !== "VIDEO") || !root.contains(media)) return;
      var parent = media.parentNode;
      if (!parent || parent.querySelector(".dps-media-error")) return;
      media.hidden = true;
      var fallback = document.createElement("span");
      fallback.className = "dps-media-error";
      fallback.setAttribute("role", "status");
      fallback.textContent = "This result image is temporarily unavailable.";
      parent.appendChild(fallback);
      analytics(root, options, "media_error", { category: state.category, caseId: activeItem() ? activeItem().id : "" });
    };
    root.addEventListener("error", mediaErrorHandler, true);
    listeners.push(function () { root.removeEventListener("error", mediaErrorHandler, true); });
    analytics(root, options, "mount", { mode: mode, categories: library.length });

    var api = {
      version: VERSION,
      setCategories: function (keys, area) {
        direct = uniqueKeys(keys || [], library);
        if (!direct.length && AREA_RULES[area || options.area]) {
          direct = relatedKeys(area || options.area, [], library).slice(0, 8);
        }
        if (!direct.length) direct = popularKeys(library, 8);
        related = relatedKeys(area || options.area || "", direct, library);
        tiers.direct = direct;
        tiers.related = related;
        state.tier = "direct";
        state.category = direct[0] || allKeys[0] || "";
        state.index = 0;
        render();
      },
      openCategory: chooseCategory,
      prefetchCategory: function (key) {
        var category = categoryByKey(library, key);
        if (category) prefetchItem(category.items[0], "high");
      },
      destroy: function () {
        destroyed = true;
        renderVersion++;
        listeners.forEach(function (remove) { remove(); });
        unlock("drawer");
        unlock("lightbox");
        root.innerHTML = "";
        root._drsknnProofStudio = null;
      }
    };
    root._drsknnProofStudio = api;
    return api;
  }

  window.DrSknnProofStudio = {
    version: VERSION,
    mount: mount,
    normalizeLibrary: normalizeLibrary,
    responsiveImageUrl: sizedPhoto,
    relatedCategoryKeys: function (area, excluded) {
      var library = normalizeLibrary();
      return relatedKeys(area, excluded || [], library);
    },
    popularCategoryKeys: function (limit) {
      return popularKeys(normalizeLibrary(), typeof limit === "number" ? limit : 8);
    },
    previewItems: function (area, limit) {
      var library = normalizeLibrary();
      var keys = AREA_RULES[area] ? relatedKeys(area, [], library) : popularKeys(library, 12);
      return interleavedItems(keys, library, Math.max(1, Number(limit || 4)));
    }
  };
})(window, document);
